import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';


const About = ({ content }) => (
  <div className="post fade-in">
    <h1 className="text-center">Rólam</h1>
    <div className="post__content">
      {ReactHtmlParser(content)}
    </div>
  </div>
);


About.propTypes = {
  content: PropTypes.string.isRequired
};


export default About;



// WEBPACK FOOTER //
// ./src/components/About/About.js